// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1kKZj","range":"MonthRangeSwitch_range__zAYie","disabled":"MonthRangeSwitch_disabled__1PaxI"};